import type { PurchaseOrderItem, PoGstMode } from '../types';
import { computePoTotals } from './nzGst';

export function newPoLine(overrides?: Partial<PurchaseOrderItem>): PurchaseOrderItem {
  return {
    lineId: `line-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    productName: '',
    quantity: 1,
    costPerUnit: 0,
    unit: 'units',
    ...overrides,
  };
}

export function poLineTotal(line: PurchaseOrderItem): number {
  return (line.quantity || 0) * (line.costPerUnit || 0);
}

/** Sum of line totals; when gstMode is set returns total inc-GST. */
export function poOrderTotal(items: PurchaseOrderItem[], gstMode?: PoGstMode): number {
  if (gstMode) {
    return computePoTotals(items, gstMode).totalIncGst;
  }
  return items.reduce((sum, line) => sum + poLineTotal(line), 0);
}
